/**
 * This home page for the Search app
 */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent, updateCurrentScreen } from "../../utils";
import { Auth } from "aws-amplify";
import { useAuth } from "../../hooks/useAuth";
import { useMediaQuery } from "react-responsive";

import {
      selectApplicationHomeData,
      selectApplicationHomeStatus,
      selectApplicationHomeError,
      initializeAsync,
} from "./applicationHomeSlice";

import {
      Button,
      Box,
      Paper,
      Menu,
      MenuItem,
      Container,
      Typography,
      Card,
      CardContent,
      CardHeader,
      Snackbar,
      Alert,
} from "@mui/material";

import { get, post } from "../../api";

import { ReactComponent as ApplicationRequirements } from "../../assets/svgs/application-requirements.svg";

import Grid from "@mui/material/Unstable_Grid2";
import { useNavigate } from "react-router-dom";
import { InlineText } from "../../components/InlineText";
import { ReactComponent as CurrancyIcon } from "../../assets/svgs/currencyCyan.svg";
import { ReactComponent as CreditCardIcon } from "../../assets/svgs/credit-card.svg";
import { ReactComponent as ThunbDownIcon } from "../../assets/svgs/thunb-down.svg";
import { ReactComponent as LocationIcon } from "../../assets/svgs/location.svg";
import { ReactComponent as FileIcon } from "../../assets/svgs/file.svg";
import { ReactComponent as HomeIcon } from "../../assets/svgs/home.svg";

import "./style.css";
import { DesktopHeader } from "../../components/DesktopHeader";

import { init, FullStory } from "@fullstory/browser";
import { LoadingButton } from "@mui/lab";
init({ orgId: process.env.REACT_APP_FULL_STORY_ORG_ID });

/**
 * ApplicationHome Component
 * @returns
 */
const ApplicationHome = () => {
      const data = useSelector(selectApplicationHomeData);
      const status = useSelector(selectApplicationHomeStatus);
      const error = useSelector(selectApplicationHomeError);
      const dispatch = useDispatch();
      const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
      let userDetails = getUserDetailsNotAsync();
      const [openToster, setOpenToster] = useState(false);
      const [tosterVariant, setTosterVariant] = useState("error");
      const [tosterMessage, setTosterMessage] = useState("");
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
      const isDesktop = useMediaQuery({ minWidth: 1180 });

      useEffect(() => {
            if (status === "idle") {
                  dispatch(initializeAsync({}));
            }
      }, [status, dispatch]);

      // const handleStartApplicationClick = () => {
      //     userDetails.applicant.currentScreen = "application-instruction";
      //     setUserDetailsNotAsync(userDetails);
      //     updateCurrentScreen(userDetails, "application-instruction", "");
      //     navigate("/application-instruction", {});
      // };

      const saveCustomAttributes = async (data) => {
            const user = await Auth.currentAuthenticatedUser();
            await Auth.updateUserAttributes(user, data);
      };

      const handleTosterClose = () => {
            setOpenToster(false);
      };

      const handleStartApplicationClick = () => {
            let nextLocation = "application"; //userDetails?.applicant?.primaryApplicant ? "quick-check" : "application";

            if (userDetails.applicant.id) {
                  userDetails.applicant.currentScreen = nextLocation;
                  setUserDetailsNotAsync(userDetails);
                  //updateCurrentScreen(userDetails, nextLocation, "");
                  navigate("/" + nextLocation, {});
            } else {
                  setLoading(true);
                  get(`applicant/getApplicants`, {
                        emailId: encodeURIComponent(userDetails.username),
                        listingId: userDetails.listingId ? encodeURIComponent(userDetails.listingId) : "",
                        convertLead: "yes",
                  }).then(async (result) => {
                        if (result.isSuccess && result.data && result.data.length > 0 && result.data[0].id) {
                              userDetails["applicant"] = result.data[0];
                              userDetails["applicants"] = result.data;
                              await saveCustomAttributes({ "custom:uniqueId": result.data[0].contactId });
                              setUserDetailsNotAsync(userDetails);
                              const query = new URLSearchParams(window.location.search);
                              const recordId = query.get("recordId");

                              FullStory("setProperties", {
                                    type: "user",
                                    properties: {
                                          displayName:
                                                userDetails.applicant?.contact?.firstName +
                                                " " +
                                                userDetails.applicant?.contact?.lastName,
                                          email: userDetails.username,
                                    },
                              });

                              navigate("/" + nextLocation, { replace: true });
                        } else {
                              setTosterVariant("error");
                              setTosterMessage(`Some error occur, please try again or contact to the support team.`);
                              setOpenToster(true);
                              setLoading(false);
                        }
                        setLoading(false);
                  });
            }
      };

      let body = (
            <>
                  {status === "initalLoading" ? (
                        <></>
                  ) : (
                        <>
                              <Container className="ApplicationHome">
                                    <Typography variant="h1" component="h1">
                                          Let’s Get Started
                                    </Typography>
                                    <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                                          These questions will let you know if you meet our minimum requirements. The
                                          application is quick, easy, and won't affect your credit score.
                                    </Typography>
                                    {isDesktop && <DesktopHeader applicant={userDetails.applicant}></DesktopHeader>}

                                    <Card sx={{ width: "100%" }}>
                                          <CardContent sx={{ width: "100%" }}>
                                                <Grid
                                                      container
                                                      sx={{ flexDirection: isDesktop ? "row" : "column-reverse" }}>
                                                      <Grid item xs={isDesktop ? 6 : 12}>
                                                            <Typography variant="cardHeading" component="div">
                                                                  Requirements for you to be considered:
                                                            </Typography>
                                                            {userDetails?.applicant?.type === "Guarantors" ? (
                                                                  <Box>
                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          Income of at least 5x the rent
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <CurrancyIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></CurrancyIcon>
                                                                              }></InlineText>
                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          A minimum TransUnion Resident
                                                                                          Score of 670
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <CreditCardIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></CreditCardIcon>
                                                                              }></InlineText>
                                                                  </Box>
                                                            ) : (
                                                                  <Box>
                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          A minimum household monthly
                                                                                          income of at least 3x the rent
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <CurrancyIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></CurrancyIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          TransUnion ResidentScore to
                                                                                          determine satisfactory credit
                                                                                          history (Some outcomes may
                                                                                          result in the requirement of
                                                                                          an additional deposit,
                                                                                          guarantor or denial)
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <CreditCardIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></CreditCardIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          {`No eviction judgments and/or unlawful detainers within the last 2-5 years (Conditions apply)`}
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <ThunbDownIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></ThunbDownIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          We recommend you to have at
                                                                                          least two years of a
                                                                                          residential history
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <LocationIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></LocationIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          No bankruptcy filings within
                                                                                          the last 2 years
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <FileIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></FileIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          No foreclosures within the
                                                                                          last 5 years
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <HomeIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></HomeIcon>
                                                                              }></InlineText>

                                                                        <InlineText
                                                                              sx={{ mt: "10px" }}
                                                                              text={
                                                                                    <Typography
                                                                                          variant="h6"
                                                                                          component="h6">
                                                                                          There’s a $75 processing fee
                                                                                          for your application
                                                                                    </Typography>
                                                                              }
                                                                              icon={
                                                                                    <CreditCardIcon
                                                                                          style={{
                                                                                                width: "16px",
                                                                                          }}></CreditCardIcon>
                                                                              }></InlineText>
                                                                  </Box>
                                                            )}
                                                      </Grid>
                                                      <Grid item xs={isDesktop ? 6 : 12}>
                                                            <Box
                                                                  sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                  }}>
                                                                  <ApplicationRequirements
                                                                        style={{
                                                                              width: "300px",
                                                                        }}></ApplicationRequirements>
                                                            </Box>
                                                      </Grid>
                                                </Grid>
                                          </CardContent>
                                    </Card>

                                    <LoadingButton
                                          onClick={handleStartApplicationClick}
                                          color="primary"
                                          type="submit"
                                          loading={loading}
                                          fullWidth
                                          variant="contained"
                                          sx={{ height: "45px" }}>
                                          Start application
                                    </LoadingButton>

                                    <Typography variant="h6" component="h6">
                                          <b>Note:</b> Pathway will also verify your household income as well as run a
                                          credit check and background check. Applicants may be asked to provide
                                          supporting documents, such as bank statements, tax returns, and other
                                          information to be used in our underwriting verification process.
                                    </Typography>
                                    <Snackbar
                                          anchorOrigin={{ vertical: "top", horizontal: "center" }}
                                          open={openToster}
                                          autoHideDuration={6000}
                                          onClose={handleTosterClose}>
                                          <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                                                {tosterMessage}
                                          </Alert>
                                    </Snackbar>
                              </Container>
                        </>
                  )}
            </>
      );

      return getPageContent(body, status, error);
};

export { ApplicationHome };
